module.exports = __webpack_public_path__ + "static/img/how-to-play-bg.31fb24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-to-play-bg.png
// module id = GMLA
// module chunks = 1